import { useDevicePassedWidth } from "./useDevicePassedWidth"

export const useDefaultFontSize = () => {
  const screenWidth = useDevicePassedWidth(screenWidth => screenWidth)

  if (screenWidth >= 1200) {
    if (screenWidth < 1600) {
      return 10
    } else if (screenWidth  < 1800) {
      return 11
    } else {
      return 12
    }
  } else {
    return 9
  }
}